import React from 'react';
import { RadioGroup, Radio } from 'react-radio-group';
import { formatValue, clearValue } from '../../utils';

export default class EIS extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isRaw: false,
            value: true
        };

        this.onChange = null;
    }

    handleRawChange = (isRaw, value) => {
        clearTimeout(this.onChange);

        this.setState({
            isRaw,
            value
        });

        this.onChange = setTimeout(this.handleChange, 1000);
    }

    handleChange = () => {
        const newState = Object.assign({},
            this.state, {
                value: this.state.isRaw ?
                    formatValue(this.state.value) : this.state.value
            }
        );

        this.props.handleChange(
            newState.isRaw, 'eis', newState.isRaw ?
                clearValue(newState.value) : newState.value
        );

        this.setState(newState);
    }

    render() {
        const { isRaw, value } = this.state;

        return (
            <div className='row'>
                <div className='col-sm-12 col-md-6 col-xl-4'>
                    <div className='pcb-input'>
                        <label>EIS</label>
                        <input
                            type='text'
                            placeholder='Enter contribution amount or select rate'
                            value={isRaw ? value : ''}
                            onChange={event =>
                                this.handleRawChange(true, event.target.value)
                            }
                        />
                    </div>
                </div>

                <div className='col-sm-12 col-md-12 col-xl-8'>
                    <div className='pcb-radio'>
                        <RadioGroup
                            className='row'
                            name='eis'
                            selectedValue={!isRaw ? value : ''}
                            onChange={value =>
                                this.handleRawChange(false, value)
                            }
                        >
                            <div className='col-6'>
                                <label className='option'>
                                    Auto-calculate
                                    <Radio value={true} />
                                    <span className='check'></span>
                                </label>
                            </div>
                            <div className='col-6'>
                                <label className='option'>
                                    Not Applicable
                                    <Radio value={false} />
                                    <span className='check'></span>
                                </label>
                            </div>
                        </RadioGroup>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Calculator/EIS.js